module.exports = __webpack_public_path__ + "img/spreadsheet.3111a1e7.png";